import * as actionTypes from './actionTypes';

export const resetWanState = () => {
  return {
    type: actionTypes.RESET_WAN_STATE,

  };
}
export const initWanStart = () => {
  return {
    type: actionTypes.INIT_WAN_START
  };
};
export const refreshWan = () => {
  return window.location.reload();
};
export const setWan = (realWan) => {
  return {
    type: actionTypes.SET_WAN,
    realWan: realWan
  };
};
export const setTenant = (tenantData) => {
  return {
    type: actionTypes.SET_TENANT,
    tenantData: tenantData
  };
};

export const fetchWscFailed = () => {
  return {
    type: actionTypes.FETCH_WSC_FAILED,
  };
};

export const fetchWanFailed = () => {
  return {
    type: actionTypes.FETCH_WAN_FAILED,
  };
};

export const initWan = () => {
  return {
    type: actionTypes.INIT_WAN
  };
};
export const restarting = (timerStart) => {
  return {
    type: actionTypes.RESTARTING,
    timerStart: timerStart
  }
}

export const podRestarting = (pSerial) => {
  return {
    type: actionTypes.POD_RESTARTING,
    pSerial: pSerial
  }
}

export const checkWan = (rMac, token, sessionToken, wait, timerStart) => {

  return {
    type: actionTypes.CHECK_WAN,
    rMac: rMac,
    token: token,
    sessionToken: sessionToken,
    wait: wait,
    timerStart: timerStart
  }


}
export const wanConnected = () => {
  return {
    type: actionTypes.WAN_CONNECTED
  }
}
export const runWifiServiceCheck = () => {
  return {
    type: actionTypes.RUN_WIFI_SERVICE_CHECK
  }
}

export const wifiServiceCheckSpinnerUpdate = () => {
  return {
    type: actionTypes.WAN_WIFI_SERVICE_CHECK_TIMER
  }
}
